<template>
  <div class="flex h-[500px] w-full max-w-sm flex-col overflow-hidden rounded-3xl border border-border/50 bg-white shadow-xl">
    <!-- Header -->
    <div class="flex items-center gap-3 bg-vet px-5 py-4">
      <img
        src="https://cdn.bubba.pet/landing/vet/vet-profile@thumbnail.avif"
        alt="Vet profile"
        class="h-10 w-10 shrink-0 rounded-full object-cover ring-2 ring-white/30"
      />
      <div>
        <div class="text-sm font-bold text-white">{{ $ts('chatPreview.doctorName') }}</div>
        <div class="flex items-center gap-1.5 text-xs text-white/80">
          <span class="h-2 w-2 rounded-full bg-emerald-400" />
          {{ $ts('chatPreview.online') }}
        </div>
      </div>
    </div>

    <!-- Messages -->
    <div class="flex-1 space-y-3 overflow-y-auto bg-muted/20 p-4">
      <div
        v-for="(msg, i) in messages"
        :key="i"
        class="max-w-[80%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed shadow-sm"
        :class="msg.role === 'vet' ? 'mr-auto rounded-tl-none bg-white text-foreground' : 'ml-auto rounded-tr-none text-white'"
        :style="msg.role === 'user' ? { backgroundColor: 'var(--color-vet)' } : {}"
      >
        {{ msg.text }}
      </div>
    </div>

    <!-- Input mock -->
    <div class="border-t border-border/40 bg-white p-4">
      <div class="flex items-center gap-2">
        <div class="flex-1 rounded-full bg-muted px-4 py-2 text-sm text-muted-foreground">
          {{ $ts('chatPreview.placeholder') }}
        </div>
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-vet text-white">
          <Icon name="tabler:send" size="16" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '#imports';

const { $ts } = useI18n();

const messages = computed(() => [
  { role: 'vet',  text: $ts('chatPreview.messages.0') },
  { role: 'user', text: $ts('chatPreview.messages.1') },
  { role: 'vet',  text: $ts('chatPreview.messages.2') },
  { role: 'user', text: $ts('chatPreview.messages.3') },
]);
</script>
